import React, { useEffect } from 'react';
import compose from 'lodash/fp/compose';
import { withCookies } from '@catalogo/core-connect/cookies';
import { withConfig } from '@catalogo/core-connect/config';
import { useCustomer } from '../hooks/customer';
import { getLoggedCustomer } from '../helpers/customer';

const redirectToLogin = (config, redirect) => () => {
  if (redirect) {
    const currentUrl = window.location.href;

    window.location.href = `${config.baseLoginUrl}?next=${currentUrl}`;
  }
};

export const withLoginRequiredToken = Component => props => {
  const { cookies, config } = props;
  const { customerId, customerToken } = getLoggedCustomer(cookies);
  const hasCustomerData = !!customerId && !!customerToken;
  const { error, called, loading } = useCustomer(customerId, customerToken);
  const customerResponse = called && !loading;
  const redirect = !hasCustomerData || (customerResponse && !!error);
  const isLogged = hasCustomerData && customerResponse && !error;

  useEffect(redirectToLogin(config, redirect), [redirect]);

  if (loading) {
    return null;
  }

  return <Component isLogged={isLogged} {...props} />;
};

export default compose(withCookies, withConfig, withLoginRequiredToken);
